export default __webpack_public_path__ + "static/media/about-team-eliza-materia.4275e93b.png";